var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(-265 -2891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 102,
    height: 102,
    transform: "translate(265 2891)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reliable_Security",
    "data-name": "Reliable Security",
    transform: "translate(281.666 2901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M76.712,35.7C60.418,31.044,39.853,10.146,39.648,9.936l-.01-.008-.008-.01a1.119,1.119,0,0,0-.2-.131,1.11,1.11,0,0,0-.187-.121,1.169,1.169,0,0,0-.229-.049,1.316,1.316,0,0,0-.223-.041,1.335,1.335,0,0,0-.221.041,1.169,1.169,0,0,0-.229.049,1.053,1.053,0,0,0-.2.126,1.034,1.034,0,0,0-.193.126l-.008.01-.013.008C37.727,10.146,17.173,31.042.869,35.7a1.2,1.2,0,0,0-.858,1.315c.3,2.2,7.7,53.828,38.779,53.828S77.271,39.213,77.572,37.015a1.2,1.2,0,0,0-.86-1.315",
    transform: "translate(0 -9.576)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M67.974,34.237c-13.983-3.993-31.63-21.928-31.807-22.11l-.008-.005-.008-.01A.947.947,0,0,0,35.98,12a1.2,1.2,0,0,0-.159-.1,1.041,1.041,0,0,0-.2-.041.558.558,0,0,0-.38,0,1.041,1.041,0,0,0-.2.041,9496012953103.5,9496012953103.5,0,0,0-.334.216l-.005.01-.01.005c-.177.182-17.817,18.115-31.8,22.11a1.031,1.031,0,0,0-.74,1.13c.259,1.885,6.607,46.19,33.281,46.19s33.022-44.306,33.279-46.19a1.032,1.032,0,0,0-.737-1.13",
    transform: "translate(3.36 -6.056)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M25.781,51.177a3.286,3.286,0,0,1-2.062-.724L8.54,38.3a3.3,3.3,0,1,1,4.127-5.154L25.35,43.3,43.734,21.774a3.3,3.3,0,1,1,5.02,4.289L28.293,50.019a3.287,3.287,0,0,1-2.511,1.158",
    transform: "translate(11.45 7.735)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.ead1805cc5fa2eeb2c620ec638fc5fca.svg";
export { ForwardRef as ReactComponent };